var _filter, _filter2, _filter3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSuccessMandate = function SvgSuccessMandate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 132 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    filter: "url(#success-mandate_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.672 42.984c16.132 11.512 14.638 35.751-1.04 45.569-16.133 11.512-42.289 11.512-58.422 0-16.472-11.122-17.193-33.796-1.06-45.308 16.132-11.512 44.39-11.773 60.522-.261Z",
    fill: "#111",
    style: {
      fill: "color(display-p3 .0667 .0667 .0667)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 35.885,
    cy: 35.885,
    r: 35.624,
    transform: "matrix(.814 -.58085 .814 .58085 0 62.836)",
    fill: "#111",
    stroke: "url(#success-mandate_svg__b)",
    style: {
      fill: "color(display-p3 .0667 .0667 .0667)",
      fillOpacity: 1
    },
    strokeWidth: 0.522
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#success-mandate_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.395 67.76c-25.314-14.385-16.739-34.98-9.287-43.48 7.342.711 25.79 2.377 40.848 3.353 18.82 1.219 19.643 37.892 11.095 42.058-8.548 4.165-7.15 5.384-42.656-1.93Z",
    fill: "#111",
    style: {
      fill: "color(display-p3 .0667 .0667 .0667)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m102.347 67.231-.01.007c-8.025 5.727-18.554 8.596-29.092 8.596s-21.067-2.87-29.093-8.596l-.004-.003c-16.36-11.047-17.068-33.548-1.056-44.974 8.024-5.726 19.077-8.662 30.144-8.727 11.067-.065 22.119 2.741 30.142 8.466 16.012 11.426 14.528 35.489-1.031 45.231Z",
    fill: "#fff",
    fillOpacity: 0.5,
    stroke: "url(#success-mandate_svg__d)",
    style: {
      fill: "#fff",
      fillOpacity: 0.5
    },
    strokeWidth: 0.406
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.885,
    cy: 35.885,
    r: 35.624,
    transform: "scale(1.15118 .82145) rotate(-45 67.698 9.83)",
    fill: "#D8D8D8",
    fillOpacity: 0.5,
    stroke: "url(#success-mandate_svg__e)",
    style: {
      fill: "color(display-p3 .8481 .8481 .8481)",
      fillOpacity: 0.5
    },
    strokeWidth: 0.522
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#success-mandate_svg__f)",
    stroke: "#111",
    strokeWidth: 5.049,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.58 49.71c2.788 1.988 7.184 2.05 9.827.163l5.402-3.854c2.299-1.64 2.213-4.367-.23-6.11-2.614-1.866-4.712-1.722-7.01-.943l-11.666 4.018c-2.298.78-4.367.943-7.01-.943-2.414-1.722-2.529-4.47-.23-6.11l5.401-3.854c2.644-1.886 7.04-1.825 9.827.164M60.807 31.769 86.666 50.22",
    style: {
      stroke: "color(display-p3 .0667 .0667 .0667)",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "success-mandate_svg__b",
    x1: 6.219,
    y1: 29.193,
    x2: 37.727,
    y2: 58.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.43,
    style: {
      stopColor: "white",
      stopOpacity: 0.43
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    stopColor: "#fff",
    stopOpacity: 0.44,
    style: {
      stopColor: "white",
      stopOpacity: 0.44
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "success-mandate_svg__d",
    x1: 38.517,
    y1: 38.837,
    x2: 65.424,
    y2: 72.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    stopColor: "#fff",
    stopOpacity: 0.06,
    style: {
      stopColor: "white",
      stopOpacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.23,
    style: {
      stopColor: "white",
      stopOpacity: 0.23
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "success-mandate_svg__e",
    x1: 6.219,
    y1: 29.193,
    x2: 37.727,
    y2: 58.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB",
    stopOpacity: 0.43,
    style: {
      stopColor: "color(display-p3 .9197 .9197 .9197)",
      stopOpacity: 0.43
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#B0AFAF",
    stopOpacity: 0.44,
    style: {
      stopColor: "color(display-p3 .6895 .6855 .6855)",
      stopOpacity: 0.44
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "success-mandate_svg__a",
    x: 2.526,
    y: 34.48,
    width: 111.491,
    height: 94.022,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 17.397
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.959
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.674072 0 0 0 0 0.674072 0 0 0 0 0.674072 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_464_9780"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_464_9780",
    result: "shape"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "success-mandate_svg__c",
    x: 15.396,
    y: 18.185,
    width: 98.936,
    height: 82.888,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.972
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.533
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.12549 0 0 0 0 0.12549 0 0 0 0 0.12549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_464_9780"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_464_9780",
    result: "shape"
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "success-mandate_svg__f",
    x: 56.101,
    y: 28.63,
    width: 35.279,
    height: 25.095,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.945
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.203
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_464_9780"
  })))));
};

export default SvgSuccessMandate;